import script from "./ConfiguratorSummaryRow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorSummaryRow.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorSummaryRow.vue?vue&type=style&index=0&id=141e8a4b&lang=css"

const __exports__ = script;

export default __exports__